import Column from '@sportson/core-web/App/layouts/Column';
import Text from 'components/Text';

interface InformationProps {
    manufacturerName: string;
    productName: string;
}

export const Information = ({ manufacturerName, productName }: InformationProps) => (
    <Column gap={['12px', null, null, '8px']}>
        {manufacturerName && (
            <Text typography="UI/12_100_0_450_uppercase" color="var(--color-neutrals-500)">
                {manufacturerName}
            </Text>
        )}

        {productName && (
            <Text as="h1" typography="UI/24_100_0_450" color="var(--text-color-default)">
                {productName}
            </Text>
        )}
        {/* TODO: Implement review here */}
    </Column>
);
